module.exports = __webpack_public_path__ + "img/banner2.54070c53.jpg";